import { useState, useCallback } from "react"
import { ToastContext, ToastOptions } from "@/contexts/ToastContext"
import { Toast } from "@/molecules/Toast"

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toast, setToast] = useState<ToastOptions | null>(null)
  const [visible, setVisible] = useState(false)

  const showToast = useCallback((options: ToastOptions) => {
    setToast(options)
    setVisible(true)
  }, [])

  const handleClose = () => {
    setVisible(false)
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {visible && toast && (
        <div className="fixed right-0 top-8 z-[99]">
          <Toast
            message={toast.message}
            onClose={handleClose}
            variant={toast.variant || "success"}
            autoClose={toast.autoClose}
          />
        </div>
      )}
    </ToastContext.Provider>
  )
}
